import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { API_URL } from '../../api/ApiSettings';
const initialState = {
        buildingNumber:'',
        city:'',
        country: '',
        customerPersonName: '',
        email: '',
        flatNumber: '',
        id: -1,
        phone: '',
        postalCode:'',
        street:''
};

export const targetCustomerSlice = createSlice({
  name: 'targetCustomer',
  initialState,
  reducers: {
    setTargetCustomerParams: (state, action) => {
        return {...state, ...action.payload}
      },
   },
  
});

export const { setTargetCustomerParams } = targetCustomerSlice.actions;

export default targetCustomerSlice.reducer;